var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"component-page-title"},[_c('div',{staticClass:"content"},[_c('h1',{attrs:{"slot":"header"},slot:"header"},[_vm._v(_vm._s(_vm.$app.router.current().title))]),_c('div',{staticClass:"locale"},[(_vm.showSpecialistRegions)?_c('n-button',{on:{"click":_vm.openSpecialistRegions}},[_vm._v(" Регионы специалистов ")]):_vm._e()],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }